import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useGlobalSearch(query) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const value = query.trim();
    if (!value) {
      setItems([]);
      setLoading(false);
      setError(false);
      return undefined;
    }

    const controller = new AbortController();
    const timer = window.setTimeout(async () => {
      setLoading(true);
      setError(false);
      try {
        const { data } = await axios.get(`${API}/search`, {
          params: { q: value, limit: 20 },
          signal: controller.signal,
        });
        setItems(Array.isArray(data?.items) ? data.items : []);
      } catch (requestError) {
        if (!axios.isCancel(requestError) && requestError?.code !== "ERR_CANCELED") {
          setError(true);
          setItems([]);
        }
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    }, 280);

    return () => {
      window.clearTimeout(timer);
      controller.abort();
    };
  }, [query]);

  return { items, loading, error };
}